import React from 'react';
import { IconsPros } from './types';

/**
 * Help Icon component
 *
 * @returns JSX.ELEMENT
 */
export const HelpIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <path d="M8,.13A7.88,7.88,0,1,0,15.88,8,7.87,7.87,0,0,0,8,.13ZM7.77,12.51a1.35,1.35,0,1,1,1.3-1.35A1.3,1.3,0,0,1,7.77,12.51Zm1-3.33h-2C6.54,7.49,8.39,6.77,8.39,5.93c0-.47-.34-.65-.73-.65a1.53,1.53,0,0,0-1.07.55l-1-.95a.25.25,0,0,1,0-.36,3.13,3.13,0,0,1,2.28-1c1.51,0,2.7.65,2.7,2.29S8.62,7.75,8.75,9.18Z" />
    </svg>
  );
};
